import axios from '@/server/axios'

export function queryArticleDetail(articleId) {
  return axios({
    url: 'officialWebsite/articleDetail.do',
    method: 'get',
    params: {
      articleId
    }
  })
}
